import type { SlateElementProps } from 'platejs/static';

import { SlateElement } from 'platejs/static';

export function ParagraphElementStatic(props: SlateElementProps) {
  return (
    <SlateElement {...props} className="m-0 px-0 py-0 plate-viewer-paragraph">
      {props.children}
    </SlateElement>
  );
}
